/* Reflect the existing campaign offer only on its exact English ad arrival. */
(() => {
  const url = new URL(window.location.href);
  if (url.pathname.replace(/\/+$/, '') !== '/pages/saudi-best-sellers') return;
  if (url.searchParams.get('utm_content') !== 'hala10-catalog-template-en-v1') return;
  if (url.searchParams.get('utm_source') !== 'meta') return;
  if (url.searchParams.get('utm_medium') !== 'paid_social') return;
  const offer = document.querySelector('.dglp[lang="en"] [data-lp-hala10]');
  if (offer) offer.hidden = false;
})();
